import React from 'react';
import styled from 'styled-components';
import {
  BaseBox,
  FlexBox,
  Icons,
  CenterBox,
  Heading3,
  Heading4,
} from '@docon/docon-ui-library';
import { borderColor, colors } from 'utilities/colorConfig';

const typeColors = {
  Vaccination: colors.purpleColor[2],
  'Follow-up': colors.success,
};

const VisitType = styled(FlexBox)`
  font-size: 16px;
  line-height: 24px;
  align-items: center;
  text-transform: capitalize;
  color: ${colors.secondaryColor};

  ${CenterBox} {
    border-radius: 7px;
    margin-right: 0.5rem;
    background-color: ${colors.warning};
  }
`;

const Content = styled(BaseBox)`
  flex: 1;
  font-weight: 500;
`;

const Root = styled(FlexBox)`
  margin-bottom: 1rem;
  cursor: pointer;
  border-radius: 8px;
  background-color: ${colors.white};
  border: 1px solid ${borderColor};

  ${Icons.ChevronIcon} {
    margin-right: 10px;
    align-self: center;
  }

  :hover {
    .date {
      color: #33b2ff;
    }
  }

  @media screen and (min-width: 800px) {
    &:hover {
      box-shadow: 0 1px 18px 0 ${colors.boxShadow};
    }

    .date {
      max-width: 105px;
    }
  }
  
  .date {
    width: 30%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid ${borderColor};

    p {
      font-size: 18px;
      line-height: 1.13;
      font-weight: 500;

      &:first-child {
        font-size: 32px;
      }
    }
  }
`;

function Card({ visit = {}, onClick }: any) {

  function handleClick() {
    // this.ganalytics.emitEmitNonInteraction(this.eventCategory, 'select_prescription', this.eventLabel, this.index);
    // this.ganalytics.setEventCustomMetrics(this.eventCategory, 'select_prescription', { metric1: this.index });
    // this.ganalytics.setEventCustomMetrics(this.eventCategory, 'select_prescription', { visitID: data.visit.visitID });
    // this.ganalytics.setEventCustomMetrics(this.eventCategory, 'select_prescription', { metric2: moment() });
    // this.ganalytics.setEventCustomMetrics(this.eventCategory, 'select_prescription', { doctorID: data.visit.doctorID });
    // this.ganalytics.setEventCustomMetrics(this.eventCategory, 'select_prescription', { metric3: this.getTimeBucket() });
    onClick({ visit });
  }

  return (
    <Root onClick={handleClick}>
      <FlexBox className='date'>
        <p>{visit.date}</p>
        <p>{visit.month}</p>
      </FlexBox>
      <Content p={'1rem'} className='ellipsis'>
        <Heading3 className='ellipsis' title={visit.patientFullName} />
        <Heading4 className='ellipsis' title={visit.doctorFullName} color={colors.secondaryColor} />
        <VisitType hidden={!visit?.visitType}>
          <CenterBox size={14} bg={typeColors[visit.visitType]} />
          <span>{visit.visitType}</span>
        </VisitType>
      </Content>
      <Icons.ChevronIcon
        type='right'
        width={20}
        color={borderColor}
      />
    </Root>
  );
}

export default Card;

